export const REMOVE_BTN_TYPE = {
  remove: 'remove',
  delete: 'delete',
} as const;
